





























import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'

@Component
export default class RenewalUserModal extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // Props

  // --------------------------------------------------------------------------------------------------------------------
  // data
  private moveMypageSetting = ''

  // -------------------------------------------------------------------------------------------------------------------
  // getter
  get isRenewalUserModalVisible(): boolean {
    return membershipState.isRenewalUserModalVisible
  }

  // -------------------------------------------------------------------------------------------------------------------
  // hooks
  private beforeMount() {
    // MyPage のsetting URLを取得
    this.moveMypageSetting =
      drupalSettings.vueComponent.membershipcontroll.myPage.setting
  }
  // -------------------------------------------------------------------------------------------------------------------
  // methods

  private close() {
    membershipState.addIsRenewalUserModalVisible(false)
  }
}
